import React from "react";
import { TruckIconFO, RailIconFO } from "../../../../icons";
import { ModeFilter, OriginTypeFilter } from "../../../../types/IFavoriteOrigins";

interface OriginManagerFiltersProps {
  priorityProducts: string[];
  selectedProduct: string;
  onProductClick: (product: string) => void;

  visibleMonths: string[];
  selectedMonths: string[];
  onToggleMonth: (month: string) => void;
  monthWindowScrollRef: React.RefObject<HTMLDivElement>;
  onMonthWindowScroll: () => void;
  canScrollMonthsBack: boolean;
  canScrollMonthsForward: boolean;
  onScrollMonthsBack: () => void;
  onScrollMonthsForward: () => void;

  modeFilter: ModeFilter;
  onModeFilterChange: (mode: ModeFilter) => void;

  originTypeFilter: OriginTypeFilter;
  onOriginTypeFilterChange: (filter: OriginTypeFilter) => void;
}

const OriginManagerFilters: React.FC<OriginManagerFiltersProps> = ({
  priorityProducts,
  selectedProduct,
  onProductClick,
  visibleMonths,
  selectedMonths,
  onToggleMonth,
  monthWindowScrollRef,
  onMonthWindowScroll,
  canScrollMonthsBack,
  canScrollMonthsForward,
  onScrollMonthsBack,
  onScrollMonthsForward,
  modeFilter,
  onModeFilterChange,
  originTypeFilter,
  onOriginTypeFilterChange,
}) => {
  return (
    <div className="dom-filter-card">
      <div className="dom-filter-row">
        <div className="dom-filter-section">
          <p className="dom-filter-label">PRODUCT</p>
          <div className="dom-chip-group">
            {priorityProducts.map((item) => (
              <button
                key={item}
                type="button"
                className={`dom-chip ${
                  selectedProduct === item ? "active" : ""
                }`}
                onClick={() => onProductClick(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="dom-vertical-divider" />

        <div className="dom-filter-section dom-window-section">
          <p className="dom-filter-label">WINDOW (MULTI SELECT)</p>
          <div id="month-window-row" className="dom-window-row">
            <button
              type="button"
              className="dom-window-caret-btn"
              onClick={onScrollMonthsBack}
              aria-label="Scroll months backward"
              disabled={!canScrollMonthsBack}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M6.5 2L3.5 5L6.5 8"
                  stroke="#62748e"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div
              ref={monthWindowScrollRef}
              className="dom-chip-group dom-window-group"
              onScroll={onMonthWindowScroll}
            >
              {visibleMonths.map((month) => (
                <button
                  key={month}
                  type="button"
                  className={`dom-chip ${
                    selectedMonths.includes(month) ? "active" : ""
                  }`}
                  onClick={() => onToggleMonth(month)}
                >
                  {month}
                </button>
              ))}
            </div>
            <button
              id="dom-window-scroll-forward-btn"
              type="button"
              className="dom-window-caret-btn"
              onClick={onScrollMonthsForward}
              aria-label="Scroll months forward"
              disabled={!canScrollMonthsForward}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3.5 2L6.5 5L3.5 8"
                  stroke="#62748e"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="dom-horizontal-divider" />

      <div className="dom-filter-row">
        <div className="dom-filter-section dom-compact-section">
          <p className="dom-filter-label">MODE</p>
          <div className="dom-chip-group dom-mode-group">
            <button
              type="button"
              className={`dom-chip ${modeFilter === "all" ? "active" : ""}`}
              onClick={() => onModeFilterChange("all")}
            >
              All
            </button>
            <button
              type="button"
              className={`dom-chip dom-mode-chip ${
                modeFilter === "truck" ? "active" : ""
              }`}
              onClick={() => onModeFilterChange("truck")}
            >
              <TruckIconFO
                size="14"
                color={modeFilter === "truck" ? "#60a5fa" : "#60a5fa"}
              />
              <span>Truck</span>
            </button>
            <button
              type="button"
              className={`dom-chip dom-mode-chip ${
                modeFilter === "rail" ? "active" : ""
              }`}
              onClick={() => onModeFilterChange("rail")}
            >
              <RailIconFO
                size="14"
                color={modeFilter === "rail" ? "#f97316" : "#f97316"}
              />
              <span>Rail</span>
            </button>
          </div>
        </div>

        <div className="dom-vertical-divider" />

        <div className="dom-filter-section dom-compact-section">
          <p className="dom-filter-label">ORIGIN TYPE</p>
          <div className="dom-chip-group">
            <button
              type="button"
              className={`dom-chip ${
                originTypeFilter === "all" ? "active" : ""
              }`}
              onClick={() => onOriginTypeFilterChange("all")}
            >
              All
            </button>
            <button
              type="button"
              className={`dom-chip ${
                originTypeFilter === "competitor" ? "active" : ""
              }`}
              onClick={() => onOriginTypeFilterChange("competitor")}
            >
              Competitor
            </button>
            <button
              type="button"
              className={`dom-chip ${
                originTypeFilter === "koch" ? "active" : ""
              }`}
              onClick={() => onOriginTypeFilterChange("koch")}
            >
              Koch
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OriginManagerFilters;
